var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Add Case Note",
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: true,
        centered: ""
      },
      on: { hide: _vm.modalClose, ok: _vm.addNote },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary", size: "sm" },
                  on: { click: _vm.modalClose }
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: { click: _vm.addNote }
                },
                [_vm._v("\n      Submit\n    ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            "label-class": "addpersonlabel",
            label: "Date",
            "label-for": "date"
          }
        },
        [
          _c("datepicker", {
            attrs: {
              name: "date",
              "input-class": "form-control-lg",
              "initial-view": "day",
              placeholder: "Select Date",
              format: this.$dateFormatter,
              "disabled-dates": { from: new Date() },
              "clear-button": ""
            },
            model: {
              value: _vm.note.customDate,
              callback: function($$v) {
                _vm.$set(_vm.note, "customDate", $$v)
              },
              expression: "note.customDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Title",
            "label-class": "addpersonlabel",
            "label-for": "title"
          }
        },
        [
          _c("b-form-input", {
            attrs: { size: "lg", type: "text", name: "title" },
            model: {
              value: _vm.note.title,
              callback: function($$v) {
                _vm.$set(_vm.note, "title", $$v)
              },
              expression: "note.title"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { staticStyle: { width: "300px" }, attrs: { label: "Type" } },
        [
          _c("v-select", {
            attrs: {
              options: _vm.noteTypes,
              label: "title",
              reduce: function(noteType) {
                return noteType.value
              },
              placeholder: "Type to Search"
            },
            model: {
              value: _vm.note.noteType,
              callback: function($$v) {
                _vm.$set(_vm.note, "noteType", $$v)
              },
              expression: "note.noteType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("b-form-textarea", {
        staticClass: "mt-3",
        attrs: { rows: "10", placeholder: "Enter Note", name: "note" },
        model: {
          value: _vm.note.note,
          callback: function($$v) {
            _vm.$set(_vm.note, "note", $$v)
          },
          expression: "note.note"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7872cbc2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7872cbc2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/AddNoteModal.vue
// module id = 1565
// module chunks = 0